<template>
  <div>
    <div class="grid grid-cols-fit-250 gap-2">
      <news-category
        v-for="category in newsCategories"
        :key="category.id"
        :category="category"
      />
    </div>
    <load-more-section
      show-count
      name="newscategory"
      @input="getNewsCategories"
    />
    <fab @input="goTo('/news-category-manage')">
      <icon name="Plus" />
    </fab>
  </div>
</template>

<script>
const NewsCategory = require("@/modules/news/components/NewsCategory.vue")
  .default;
const Fab = require("@/modules/core/components/Fab.vue").default;
const LoadMoreSection = require("@/modules/core/components/LoadMoreSection.vue")
  .default;

export default {
  name: "NewsCategoriesSite",
  data() {
    return {
      newsCategories: null,
    };
  },
  props: {},
  components: {
    NewsCategory,
    Fab,
    LoadMoreSection,
  },
  methods: {
    async getNewsCategories() {
      this.newsCategories = await this.getEntity("newscategory");
    },
  },
  computed: {},
  async created() {
    await this.getNewsCategories();
  },
};
</script>